import { injectable } from 'tsyringe';
import { ContentRecommendationUserAction } from '../../../shared/constants';
import { TrackEvent } from '../../../shared/models/tracking-event.model';
import { LoggerService } from '../../../shared/services/logger.service';
import { PromotionAnalyticsTracker } from './promotion-analytics-tracker';
import { PromotionType } from '../datastore-service/models/raw-promotion.model';

// -----------------------------------------------------------------------------
export interface IPromotionAnalyticsService {
  reportContentRecommend(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    userAction: any,
  );
  reportOfferAction(gameId: number, promotionId: string, userAction: any);
  reportContentViewEvent(event: TrackEvent);
  reportContentViewError(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
  );
  reportAppLaunched(gameId: number);
  reportPromotionSettingChanged(enable: boolean);
}

export const kNameOfPromotionAnalyticsService = 'PromotionAnalyticsService';
// -----------------------------------------------------------------------------
@injectable()
export class PromotionAnalyticsService implements IPromotionAnalyticsService {
  private readonly logger = LoggerService.getCategory(
    'PromotionAnalyticsService',
  );

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly promotionAnalyticsTracker: PromotionAnalyticsTracker,
  ) {}

  // ---------------------------------------------------------------------------
  // IPromotionAnalyticsService
  // ---------------------------------------------------------------------------

  // --------------------------------------------------------------------
  reportContentViewError(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
  ) {
    if (promotionType === PromotionType.Offer) {
      this.promotionAnalyticsTracker.sendPromotionOfferAnalyticsError(
        gameId,
        promotionId,
      );
    } else {
      this.promotionAnalyticsTracker.sendPromotionAnalyticsError(
        gameId,
        promotionId,
      );
    }
  }

  // ---------------------------------------------------------------------------
  reportContentRecommend(
    gameId: number,
    promotionId: string,
    promotionType: PromotionType,
    userAction: ContentRecommendationUserAction,
  ) {
    if (promotionType === PromotionType.Offer) {
      this.promotionAnalyticsTracker.sendPromotionOfferRecommend(
        gameId,
        promotionId,
        userAction,
      );
    } else {
      this.promotionAnalyticsTracker.sendPromotionRecommend(
        gameId,
        promotionId,
        userAction,
      );
    }
  }

  // ---------------------------------------------------------------------------
  reportOfferAction(
    gameId: number,
    promotionId: string,
    userAction: ContentRecommendationUserAction,
  ) {
    this.promotionAnalyticsTracker.sendOfferAction(
      gameId,
      promotionId,
      userAction,
    );
  }

  // ---------------------------------------------------------------------------
  reportContentViewEvent(event: TrackEvent) {
    this.promotionAnalyticsTracker.sendContentViewEvent(event);
  }

  // ---------------------------------------------------------------------------
  reportAppLaunched(gameId: number) {
    this.promotionAnalyticsTracker.sendAppLaunched(gameId);
  }

  // ---------------------------------------------------------------------------
  reportPromotionSettingChanged(enable: boolean) {
    this.promotionAnalyticsTracker.sendPromotionSettingChanged(enable);
  }
}
